import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './functionDataController.json';

const getFunctionData = (req, res, ctx) => {
  const responseData = MOCK_DATA['functionDataController/getFunctionData'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('functionDataController/getFunctionData'), withScenario(withAuthCheck(getFunctionData))),
];
